<template>
  <div class="container">
    <!-- 加载中 -->
    <div v-if="loading" class="loading-wrap">
      <div class="spinner"></div>
      <p>正在加载订单信息...</p>
    </div>

    <!-- 主页面：展示金额 + 授权按钮 -->
    <div v-else-if="show" class="main">
      <div class="top">
        <div class="img">
					<img style="width: 50px; height: 50px" :src="url" fit="contain" />
				</div>
        <span class="tit">微信收款</span>
        <span class="price">¥{{ orderInfoPrice }}</span>
        <div class="desc">
          <span>收款说明：</span>
          <span>1、请使用【收款人】本人微信收款，且微信需要实名认证及绑定银行卡。</span>
          <span>2、若本人微信无法收款，请联系店员处理。</span>
        </div>
      </div>

      <div class="bottom">
        <div
          @click="handleAuth"
          :class="['code', { loading: loadingAuth }]"
          :style="{ opacity: loadingAuth ? 0.7 : 1 }"
        >
          {{ loadingAuth ? '正在收款中，请耐心等待...' : '授权微信收款' }}
        </div>
      </div>
    </div>

    <!-- 结果页 -->
    <div v-else class="result-wrap">
      <div class="result-icon">
        <img
          style="width: 108px; height: 100px"
          :src="statu === 1 ? successImg : failImg"
          fit="contain"
        />
      </div>
      <div class="result-tit">{{ statu === 1 ? '收款成功' : '收款失败' }}</div>
      <div class="result-desc" v-if="statu === 2">
        请确认微信是否绑定【收款人】姓名的本人银行卡及已实名
      </div>
    </div>
  </div>
</template>

<script>
import {
  getOrderByorderID,
  getWechatOpenId,
  wxPayTransfer,
} from "@/api/index"
import { wxAppId } from "@/config"

export default {
  name: "WechatPay",
  data() {
    return {
      orderId: null,
      openId: null,
      realName: null,
      orderInfoPrice: 0,
      loading: true,
      show: false,
      loadingAuth: false,
      statu: 1,
      successImg: require('@/assets/success.png'),
      failImg: require('@/assets/fail.png'),
      url: require('@/assets/wechat_icon.png'),
    }
  },
  created() {
    document.title = '微信收款';
    this.orderId = this.$route.query.orderId
    this.openId = this.$route.query.openId || null
    this.realName = this.$route.query.realName || null

    if (!this.orderId) {
      this.$message.error('缺少订单信息，请重新扫码')
      this.loading = false
      return
    }

    // 检测是否在微信客户端内
    const ua = navigator.userAgent.toLowerCase()
    const inWechat = ua.indexOf('micromessenger') !== -1

    // 如果 URL 带了 OAuth code，说明是授权回调，用 code 换 openId
    const code = this.$route.query.code
    if (inWechat && code && !this.openId) {
      this.exchangeCodeForOpenId(code).then(() => {
        this.loadOrderInfo()
      }).catch(() => {
        this.loading = false
      })
    } else {
      this.loadOrderInfo()
    }
  },
  methods: {
    async loadOrderInfo() {
      try {
        const res = await getOrderByorderID(this.orderId)
        this.orderInfoPrice = res.data.data
        this.loading = false
        this.show = true
      } catch (err) {
        this.loading = false
        this.$message.error('查询订单信息失败，请联系管理员')
      }
    },

    /** 用微信 OAuth code 换取 openId */
    async exchangeCodeForOpenId(code) {
      try {
        const res = await getWechatOpenId({ code })
        const openId = res.data && (res.data.msg || res.data.openId)
          ? (res.data.msg || res.data.openId)
          : (res.msg || res.openId)
        if (!openId) throw new Error('返回数据中无 openId')
        this.openId = openId
      } catch (err) {
        console.error('获取 openId 失败:', err)
        this.$message.error('获取微信身份信息失败，请刷新重试')
        throw err
      }
    },

    /** 跳转微信 OAuth 静默授权页，回调回本页面 */
    redirectToWechatOAuth() {
      const basePath = window.location.href.split('#')[0]
      const redirectUri = encodeURIComponent(
        basePath + '#/wechat_pay?orderId=' + this.orderId
          + (this.realName ? '&realName=' + encodeURIComponent(this.realName) : '')
      )
      const oauthUrl =
        'https://open.weixin.qq.com/connect/oauth2/authorize' +
        '?appid=' + wxAppId +
        '&redirect_uri=' + redirectUri +
        '&response_type=code' +
        '&scope=snsapi_base' +
        '&state=' + this.orderId +
        '#wechat_redirect'
      window.location.href = oauthUrl
    },

    async handleAuth() {
      if (this.loadingAuth) return
      this.loadingAuth = true

      // 检测是否在微信客户端内
      const ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('micromessenger') === -1) {
        this.$message.error('请在微信客户端打开')
        this.loadingAuth = false
        return
      }

      // 若没有 openId，先走 OAuth 静默授权
      if (!this.openId) {
        this.redirectToWechatOAuth()
        return
      }

      try {
        // 1. 调用后端接口发起商家转账，获取 mch_id + packageInfo
        const params = { orderId: this.orderId, openId: this.openId }
        if (this.realName) params.realName = this.realName

        const transferRes = await wxPayTransfer(params)
        const data = transferRes.data || transferRes
        const mchId = data.mch_id
        const packageInfo = data.packageInfo

        if (!mchId || !packageInfo) {
          this.$message.error('发起转账失败，请联系管理员')
          this.loadingAuth = false
          return
        }

        // 2. 等待 WeixinJSBridge 就绪
        await this.ensureWeixinJSBridge()

        // 3. 调用 requestMerchantTransfer 拉起确认页
        WeixinJSBridge.invoke('requestMerchantTransfer', {
          mchId,
          appId: wxAppId,
          package: packageInfo,
        }, (invokeRes) => {
          this.loadingAuth = false
          if (invokeRes.err_msg === 'requestMerchantTransfer:ok') {
            document.title = '收款成功'
            this.statu = 1
            this.show = false
          } else if (invokeRes.err_msg === 'requestMerchantTransfer:cancel') {
            document.title = '收款已取消'
            this.statu = 2
            this.show = false
          } else {
            document.title = '收款失败'
            this.statu = 2
            this.show = false
          }
        })
      } catch (err) {
        console.error('微信收款处理失败:', err)
        this.$message.error('微信收款处理失败，请联系管理员')
        this.loadingAuth = false
      }
    },

    ensureWeixinJSBridge() {
      return new Promise((resolve, reject) => {
        if (window.WeixinJSBridge) { resolve(); return }

        if (typeof document.addEventListener !== 'undefined') {
          document.addEventListener('WeixinJSBridgeReady', resolve, false)
        }

        setTimeout(() => {
          if (window.WeixinJSBridge) resolve()
          else reject(new Error('WeixinJSBridge 加载超时'))
        }, 10000)
      })
    },
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  min-height: 96vh;
  background: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.loading-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 96vh;
  color: #999;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #07C160;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.main {
  height: 96vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 10px;
  box-sizing: border-box;
}

.top {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 36px;
}

.top .img {
		width: 100%;
		height: 50px;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
}

.icon-wrap {
  margin-bottom: 12px;
}

.tit {
  color: #333;
  font-size: 16px;
  font-weight: 500;
}

.price {
  margin: 30px 0 60px;
  color: #FF5946;
  font-size: 36px;
}

.desc {
  width: 100%;
  background: rgba(255, 245, 245, 1);
  border-radius: 4px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  color: rgb(251, 51, 42);
  font-size: 14px;
  padding-left: 10px;
  box-sizing: border-box;
}

.bottom {
  padding: 10px 26px;
}

.code {
  width: 100%;
  height: 37px;
  border-radius: 42px;
  background: rgba(40, 196, 69, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.code.loading {
  background: #aaa;
  cursor: not-allowed;
}

.code:active:not(.loading) {
  transform: scale(0.98);
}

.result-wrap {
  height: 96vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.result-icon {
  margin-bottom: 12px;
}

.result-tit {
  color: #333;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
}

.result-desc {
  color: #999;
  font-size: 14px;
  text-align: center;
  width: 60%;
}
</style>
